// extracted by mini-css-extract-plugin
export default {"description":"style_description__4IxPs","body":"style_body__ipM5b","mask":"style_mask__MRPuT","button":"style_button__SSVPx","moreWork":"style_moreWork__JxJLh"};